import { z } from "zod";

import { CaseStep } from "../case-core";
import { CaseNumberSchema, CaseRecordSchema } from "./records";

const CaseApiResponseSchema = CaseRecordSchema.partial().extend({
  id: z.uuid().meta({ visibleTo: "*" }),
  clientId: z.uuid().meta({ visibleTo: "*" }),
  caseType: CaseRecordSchema.shape.caseType,
  step: CaseStep.meta({ visibleTo: "*" }),
  createdAt: z.iso.datetime().meta({ visibleTo: "*" }),
  updatedAt: z.iso.datetime().meta({ visibleTo: "*" }),
});

export type CaseApiResponse = z.infer<typeof CaseApiResponseSchema>;

export const FinalizedCaseApiResponseSchema = CaseApiResponseSchema.extend({
  caseNumber: CaseNumberSchema.meta({ visibleTo: "*" }),
});
export type FinalizedCaseApiResponse = z.infer<typeof FinalizedCaseApiResponseSchema>;

const CaseListRecordSchema = CaseRecordSchema.pick({
  id: true,
  caseNumber: true,
  clientId: true,
  branchId: true,
  caseType: true,
  step: true,
  externalCode: true,
  incident: true,
  liableVehicles: true,
  vehicle: true,
  contacts: true,
  damages: true,
  debt: true,
  clientName: true,
  branchName: true,
  prescriptionPeriodYears: true,
  createdAt: true,
  updatedAt: true,
  activities: true,
}).extend({});

export const ListCaseRecordsResponseSchema = z.object({
  items: z.array(CaseListRecordSchema).meta({ visibleTo: "*" }),
  nextToken: z
    .string()
    .optional()
    .describe("Opaque pagination cursor; pass as nextToken to fetch more")
    .meta({ visibleTo: "*" }),
});
export type ListCaseRecordsResponse = z.infer<typeof ListCaseRecordsResponseSchema>;

const CaseListApiResponseSchema = CaseListRecordSchema.partial().extend({
  id: CaseRecordSchema.shape.id,
  caseNumber: CaseRecordSchema.shape.caseNumber,
  clientId: CaseRecordSchema.shape.clientId,
  caseType: CaseRecordSchema.shape.caseType,
  step: CaseRecordSchema.shape.step,
  createdAt: CaseRecordSchema.shape.createdAt,
  updatedAt: CaseRecordSchema.shape.updatedAt,
});

export const ListCaseApiResponsesSchema = z.object({
  items: z.array(CaseListApiResponseSchema).meta({ visibleTo: "*" }),
  nextToken: z.string().optional().meta({ visibleTo: "*" }),
});
export type ListCaseApiResponses = z.infer<typeof ListCaseApiResponsesSchema>;
